module.exports = __webpack_public_path__ + "media/images/home/icon_collapse_hide-8740f0c00122c0130b25ae27fc6d40d1.svg";